import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(id) {
  return yield oncallFetch("/api/oncall/partners/engineers/get-by-id", { id });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/engineers/get-by-id.js